import Vue from 'vue'
import App from './App'
import axios from 'axios'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import router from './router'
import Vuex from 'vuex'
import store from './store'

// ElementUI 
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// Vue-Swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// Moment
import moment from 'moment'
import 'moment/locale/zh-cn'
Vue.prototype.$moment = moment

// Vue-mobile-calendar
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar);

// Mint UI
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(Mint);

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Vuex)

/* eslint-disable no-new */

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);


import { getLocalStorage } from '@/utils'

// 修正vue-router新版本报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach(async (to,from,next)=>{         //to--即将要进入的路由 from--当前导航正要离开的路由
  window.document.title = to.meta.title
  
  // if ((to.name !== '登录') && !getLocalStorage('token')) {
  //   next ({name: '登录'})
  // }
  // window.gtag('config', 'UA-89364046-47', {
  //     page_title: to.meta.title,
  //     page_path: to.path,
  //     // page_location: location
  // })
  next()
})

router.afterEach(async (to, from, next) => {
  if (!to.meta.isBack){
    window.scrollTo(0,0)
  }
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js